export default defineNuxtRouteMiddleware((to, from) => {
    const token = useCookie('auth_token', { path: '/' })

    // Public routes that don't require auth
    if (to.path === '/auth/login' || to.path === '/auth/setup' ||
        to.path === '/auth/forgot-password' || to.path === '/auth/reset-password') {
        if (token.value) {
            return navigateTo('/')
        }
        return
    }

    // If user is not authenticated and tries to access restricted pages
    const refresh = useCookie('refresh_token', { path: '/', maxAge: 60 * 60 * 24 * 7 })
    if (!token.value && !refresh.value) {
        return navigateTo('/auth/login')
    }
})
